module.exports = __webpack_public_path__ + "static/media/Sony SmartWatch 3 Black Closed.fa796529.png";